const handleDownload = async (ipfsUrl) => {
  const response = await fetch(ipfsUrl);

  if (!response.ok) {
    console.error("Failed to fetch the file");
    return;
  }

  const blob = await response.blob();

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "downloaded_file";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export { handleDownload };
